__turbopack_context__.v({
  "clearBtn": "dSOCYq_clearBtn",
  "count": "dSOCYq_count",
  "filterBtn": "dSOCYq_filterBtn",
  "left": "dSOCYq_left",
  "right": "dSOCYq_right",
  "searchBtn": "dSOCYq_searchBtn",
  "searchContainer": "dSOCYq_searchContainer",
  "searchForm": "dSOCYq_searchForm",
  "searchInput": "dSOCYq_searchInput",
  "searchOptions": "dSOCYq_searchOptions",
  "tabsRow": "dSOCYq_tabsRow",
  "title": "dSOCYq_title",
  "titleContainer": "dSOCYq_titleContainer",
  "toolbar": "dSOCYq_toolbar",
  "wrapper": "dSOCYq_wrapper",
});
